<template lang="pug">
.loader(:class="{ 'has-error': status.error }")
  .loader__inner
  p.loader__error(:class="{ visible: status.error }") {{ $root.error }}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['status'])
  },
}
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 2.75rem;
  min-height: 650px;

  &.has-error {
    .loader__inner {
      &::before {
        color: $orange;
      }

      &::after {
        color: darken($orange, 15%);
      }
    }

    .loader__error {
      opacity: 1;
      visibility: visible;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    animation: rotate 2s ease infinite;
    height: 50px;
    width: 50px;

    &::before,
    &::after {
      border-radius: 50%;
      content: '';
      display: block;
      height: 20px;
      width: 20px;
      transition: color .75s ease;
    }

    &::before {
      animation: ball1 1s ease infinite;
      color: $blue;
      background-color: currentColor;
      box-shadow: 30px 0 0 $lightGray;
      margin-bottom: 10px;
    }

    &::after {
      animation: ball2 1s ease infinite;
      align-self: flex-end;
      color: $teal;
      background-color: currentColor;
      box-shadow: -30px 0 0 darken($lightGray, 20%);
    }
  }

  &__error {
    @include fontHeadings;
    @include fluid(font-size, 1.125rem, 1.25rem);
    font-style: italic;
    opacity: 0;
    visibility: hidden;
    color: $orange;
    transition: 0.75s ease;
    text-align: center;
    line-height: 1.5;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1.75);
  }

  50% {
    transform: rotate(180deg) scale(2.25);
  }

  100% {
    transform: rotate(360deg) scale(1.75);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 $lightGray;
  }

  50% {
    box-shadow: 0 0 0 $lightGray;
    transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 $lightGray;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: -30px 0 0 darken($lightGray, 20%);
  }

  50% {
    box-shadow: 0 0 0 darken($lightGray, 20%);
    transform: translate(-15px, -15px);
  }

  100% {
    box-shadow: -30px 0 0 darken($lightGray, 20%);
  }
}
</style>